import React from "react";

const Policy = () => {
  return (
    <div className="bg-[#f5f7fb] min-h-screen py-10 px-4">

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-6 md:p-10">

        {/* HEADER */}
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Privacy Policy
        </h1>

        <p className="text-sm text-gray-500 mb-6">
          Last Updated: Mar 2026
        </p>

        {/* INTRO */}
        <p className="text-gray-700 mb-6 leading-relaxed">
          This Privacy Policy describes how <b>LappyShop</b> collects, uses, and protects your information when you use our website.
          By using our service, you agree to the collection and use of information in accordance with this policy.
        </p>

        {/* SECTION */}
        <Section title="1. Information We Collect">
          <ul className="list-disc pl-5 space-y-1">
            <li>Name, email address, phone number</li>
            <li>Shipping and billing address</li>
            <li>Usage data (pages visited, time spent)</li>
          </ul>
        </Section>

        <Section title="2. How We Use Your Data">
          <ul className="list-disc pl-5 space-y-1">
            <li>To process your orders</li>
            <li>To improve user experience</li>
            <li>To send updates and offers</li>
          </ul>
        </Section>

        <Section title="3. Cookies & Tracking">
          <p>
            We use cookies to enhance your browsing experience and analyze website traffic.
            You can disable cookies in your browser settings.
          </p>
        </Section>

        <Section title="4. Sharing Your Information">
          <p>
            We do not sell your data. We may share it with trusted partners for payment processing,
            delivery, and analytics purposes.
          </p>
        </Section>

        <Section title="5. Data Security">
          <p>
            We use industry-standard security measures to protect your personal data.
            However, no method is 100% secure.
          </p>
        </Section>

        <Section title="6. Your Rights">
          <p>
            You can request access, update, or deletion of your data anytime by contacting us.
          </p>
        </Section>

        <Section title="7. Third-Party Links">
          <p>
            Our website may contain links to other sites. We are not responsible for their privacy policies.
          </p>
        </Section>

        <Section title="8. Changes to This Policy">
          <p>
            We may update this policy from time to time. Changes will be posted on this page.
          </p>
        </Section>

        <Section title="9. Contact Us">
          <p>
            📧 Email: support@lappyshop.com <br />
            📞 Phone: +91-9871238339 <br />
            🌐 Website: www.lappyshop.com
          </p>
        </Section>

      </div>

    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h2 className="text-lg md:text-xl font-semibold mb-2">
      {title}
    </h2>
    <div className="text-gray-700 text-sm leading-relaxed">
      {children}
    </div>
  </div>
);

export default Policy;